<template>
  <div class="auth-page">
    <div class="container page d-flex h-100">
      <div class="row w-100 align-items-center">
        <div class="col-md-6 offset-md-3 col-xs-12">
          <card class="auth-page__form" :class="{ 'error': error }" title="Sign In">
            <form @submit.prevent="onSubmit(email, password)">
              <fieldset>
                <div class="form-group">
                  <input
                    class="form-control form-control-lg mb-3"
                    type="text"
                    v-model="email"
                    placeholder="Email"
                    required
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control form-control-lg mb-3"
                    type="password"
                    v-model="password"
                    placeholder="Password"
                    required
                  />
                </div>
                <button
                  class="btn pull-xs-right"
                  :class="error ? 'btn-danger' : 'btn-primary'"
                >
                  {{ submitting ? 'Logging In...' : 'Log In' }}
                </button>
              </fieldset>

              <p class="text-xs-center mt-4">
                <router-link :to="{ name: 'reset password' }">
                  Forgot password?
                </router-link>
              </p>
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { LOGIN } from '@/store/actions.type'

export default {
  data() {
    return {
      email: null,
      error: false,
      password: null,
      submitting: false
    };
  },

  methods: {
    onSubmit(email, password) {
      this.submitting = true
      this.$store
        .dispatch(LOGIN, { email, password })
        .then(() => {
          this.$router.push({ name: "dashboard" })
        })
        .catch(({ response }) => {
          // console.log(response)
          this.error = true
          setTimeout(() => {
            this.error = false
          }, 500)
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.auth-page {
  background-color: #dee5ed;
  background-image: linear-gradient(124deg, #dee5ed 0%, #bfdeff 100%);
  height: 100vh;

  &__form {
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  }
}

.error {
  animation: error-shake 0.5s 1 cubic-bezier(0.33, 1, 0.68, 1);
}

@keyframes error-shake {
  0%  { transform: translateX(0%) }
  20% { transform: translateX(3%) }
  40%  { transform: translateX(-3%) }
  60% { transform: translateX(3%) }
  80%  { transform: translateX(-3%) }
  100% { transform: translateX(0) }
}
</style>
